import React from "react";
var RollCart = function RollCart(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    className: "asc-svg-icon-plus--fill-area-one",
    fill: "#00B095",
    d: "M33.96 51.56h36.72s8.16 0 8.16 8.32v16.64s0 8.32-8.16 8.32H33.96s-8.16 0-8.16-8.32V59.88s0-8.32 8.16-8.32M88.16 89a4.16 4.16 0 1 0 8.32 0 4.16 4.16 0 0 0-8.32 0m-79 0a4.16 4.16 0 1 0 8.32 0 4.16 4.16 0 0 0-8.32 0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "asc-svg-icon-plus--fill-area-two",
    fill: "#fff",
    fillOpacity: ".6",
    d: "M70.68 51.56H33.96c-2.164 0-4.24.877-5.77 2.437a8.4 8.4 0 0 0-2.39 5.883h53.04c0-2.207-.86-4.323-2.39-5.883a8.08 8.08 0 0 0-5.77-2.437"
  }), /*#__PURE__*/React.createElement("path", {
    className: "asc-svg-icon-plus--stroke",
    stroke: "#1A1A1A",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2",
    d: "M5 84.84h94.64m-7.28 0V35c0-13.255-10.745-24-24-24H37.32c-13.255 0-24 10.745-24 24v49.84M52.84 11v11.44m-12.48 1.04h24.96"
  }), /*#__PURE__*/React.createElement("path", {
    className: "asc-svg-icon-plus--stroke",
    stroke: "#1A1A1A",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2",
    d: "M42.44 51.56v-3.813a7.52 7.52 0 0 1 2.322-5.386 8.07 8.07 0 0 1 5.582-2.241h3.952a8.07 8.07 0 0 1 5.582 2.24 7.52 7.52 0 0 1 2.322 5.387v3.813m-28.24 0h36.72s8.16 0 8.16 8.32v16.64s0 8.32-8.16 8.32H33.96s-8.16 0-8.16-8.32V59.88s0-8.32 8.16-8.32"
  }), /*#__PURE__*/React.createElement("path", {
    className: "asc-svg-icon-plus--fill-area-two",
    fill: "#fff",
    fillOpacity: ".6",
    d: "M88.16 89a4.16 4.16 0 1 0 8.32 0 4.16 4.16 0 0 0-8.32 0m-79 0a4.16 4.16 0 1 0 8.32 0 4.16 4.16 0 0 0-8.32 0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "asc-svg-icon-plus--stroke",
    stroke: "#1A1A1A",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2",
    d: "M88.16 89a4.16 4.16 0 1 0 8.32 0 4.16 4.16 0 0 0-8.32 0m-79 0a4.16 4.16 0 1 0 8.32 0 4.16 4.16 0 0 0-8.32 0"
  }));
};
RollCart.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 104 104",
  fill: "none"
};
import createIconPlusComponent from '../createIconPlusComponent';
export const RollCartIconPlus = createIconPlusComponent(RollCart, 'RollCart');